document.addEventListener('DOMContentLoaded', function () {
    // 初始化 Swiper
    const swiper = new Swiper('.sell-point-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        pagination: {
            el: '.fun-dot',
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // 选项卡切换功能
    const tabItems = document.querySelectorAll('.tab-item');
    const tabHighlight = document.querySelector('.tab-highlight');
    const slides = document.querySelectorAll('.swiper-slide');
    const tabsContainer = document.querySelector('.sell-point-tabs');

    // Initialize highlight for the default active tab
    const initialActiveTab = document.querySelector('.tab-item.active');
    if (initialActiveTab) {
        // Use a small timeout to ensure the layout is stable
        setTimeout(() => {
            updateHighlight(initialActiveTab);
            scrollTabToCenter(initialActiveTab);
        }, 100);
    }

    // 检测是否为移动端
    function isMobile() {
        return window.innerWidth <= 768;
    }

    // 移动端选项卡居中滑动功能
    function scrollTabToCenter(activeTab) {
        if (!isMobile() || !tabsContainer || !activeTab) return;

        const containerWidth = tabsContainer.offsetWidth;
        const tabLeft = activeTab.offsetLeft;
        const tabWidth = activeTab.offsetWidth;
        const tabCenter = tabLeft + tabWidth / 2;
        const containerCenter = containerWidth / 2;

        // 计算需要滚动的距离
        const scrollLeft = tabCenter - containerCenter;

        // 平滑滚动到目标位置
        tabsContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
        });
    }

    // 初始化高亮块位置
    function updateHighlight(activeTab) {
        if (tabHighlight && activeTab) {
            const tabSelector = activeTab.parentElement;

            // 临时移除active状态以获取原始宽度
            const wasActive = activeTab.classList.contains('active');
            if (wasActive) {
                activeTab.classList.remove('active');
            }

            // 获取tab-item的原始宽度和高度（不含加粗效果）
            const width = activeTab.offsetWidth;
            const height = activeTab.offsetHeight;

            // 恢复active状态
            if (wasActive) {
                activeTab.classList.add('active');
            }

            // 使用getBoundingClientRect获取更精确的位置
            const tabSelectorRect = tabSelector.getBoundingClientRect();
            const activeTabRect = activeTab.getBoundingClientRect();
            // 计算相对于tab-selector的左偏移
            const left = activeTabRect.left - tabSelectorRect.left - (0.3 / 100) * window.innerWidth;

            tabHighlight.style.width = width - 6 + 'px';
            tabHighlight.style.height = height + 'px';
            tabHighlight.style.transform = `translateX(${left}px)`;
        }
    }



    tabItems.forEach((tab, index) => {
        tab.addEventListener('click', function () {
            // 移除所有选项卡的 active 状态
            tabItems.forEach(item => item.classList.remove('active'));

            // 添加当前选项卡的 active 状态
            this.classList.add('active');

            // 更新高亮块位置
            updateHighlight(this);
            // 移动端滑动居中
            scrollTabToCenter(this);
            // 切换到对应的幻灯片
            swiper.slideTo(index);
        });
    });

    // 监听 Swiper 切换事件，同步选项卡状态
    swiper.on('slideChange', function () {
        const activeIndex = swiper.activeIndex;
        tabItems.forEach((item, index) => {
            if (index === activeIndex) {
                item.classList.add('active');
                updateHighlight(item);
                scrollTabToCenter(item);
            } else {
                item.classList.remove('active');
            }
        });
    });
 new Swiper('.escapes-swiper', {
    slidesPerView: 1,
    loop:true,
    speed: 300,
    effect: 'fade',
    clickable: true,
    fadeEffect: {
      crossFade: true
    },
      pagination: {
      el: '.escapes-dot',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
    },
    navigation: {
      nextEl: '.escape-button-next',
      prevEl: '.escape-button-prev',
    },
    breakpoints: {
      // 只在移动端启用
      768: {
        enabled: false,
      }
    }
  });
   
});
